import qs from 'qs'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getImage } from '../../components/helpers/FormatLinks'
import Page from '../../components/page/Page'
import { useSharedState } from '../../components/waxplorer/Waxplorer'
import { DropPaper } from '../../components/drops/DropPaper'
import TradeNavItem from '../../components/trading/TradeNavItem'
import { TradeBreadCrumbs } from '../../components/trading/TradeBreadCrumbs'
import { get } from '../../components/helpers/Api'

const TradePage = (props) => {
    let values =
        typeof window !== 'undefined'
            ? qs.parse(
                  window.location.search.substring(
                      1,
                      window.location.search.length,
                  ),
              )
            : []

    const { t } = useTranslation('common')

    const [state, dispatch] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : values['user']

    const image = getImage(userName)

    const [receivedTrades, setReceivedTrades] = useState([])

    const [sentTrades, setSentTrades] = useState([])

    const items = [
        {
            name: t('trading.new_trade_offer'),
            description: t('trading.new_trade_offer_description'),
            href: `/trade/new`,
            condition: true,
        },
        /*   {
            name: 'New Buy Offer',
            description: t('trading.sent_trade_offers_description', {
                x: sentTrades ? sentTrades.length : 0,
            }),
            highlight: sentTrades ? sentTrades.length : 0,
            href: `/trade/new-buy`,
            condition: true,
        }, */
        {
            name: t('trading.received_trade_offers'),
            description: t('trading.received_trade_offers_description', {
                x: receivedTrades ? receivedTrades.length : 0,
            }),
            highlight: receivedTrades ? receivedTrades.length : 0,
            href: `/trade/received`,
            condition: true,
        },
        {
            name: t('trading.sent_trade_offers'),
            description: t('trading.sent_trade_offers_description', {
                x: sentTrades ? sentTrades.length : 0,
            }),
            highlight: sentTrades ? sentTrades.length : 0,
            href: `/trade/sent`,
            condition: true,
        },
    ]

    useEffect(() => {
        if (userName) {
            get(`get-received-trade-offers/${userName}`).then(setReceivedTrades)
            get(`get-sent-trade-offers/${userName}`).then(setSentTrades)
        }
    }, [userName])

    return (
        <Page
            id="TradePage"
            image={image}
            banners={false}
            {...props}
            pageTitle={t('pages.trading')}
            pageSubtitle={t('pages.explore_trading')}
            breadcrumbs={[
                {
                    title: 'Home',
                    link: '/',
                },
                {
                    title: 'Trade',
                    link: '/trade',
                },
            ]}
        >
            <div className="mx-2 sm:mx-[4vw]">
                <div className="flex flex-row items-center justify-between flex-1"></div>
                <h1 className="my-2 text-2xl font-semibold lg:text-4xl sm:text-3xl"></h1>
                <h2 className="my-2 text-base font-light text-gray-400"></h2>

                <div className="flex flex-col w-full mt-2">
                    <DropPaper title={t('navigation.trading')}>
                        {items.map((item) =>
                            item.condition ? <TradeNavItem item={item} /> : '',
                        )}
                    </DropPaper>
                </div>
            </div>
        </Page>
    )
}

export default TradePage
